// extracted by mini-css-extract-plugin
export default {"layout":"layout___Tv3AK","pad":"pad___AmZy8","secondaryContent":"secondaryContent___hpKUl","blocksContainer":"blocksContainer___BuxFg","block":"block___K0325"};